import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sdg-reports-dashboard" }
const _hoisted_2 = { class: "company_lists__select" }

import { ref } from "vue";

import EmptyState from "./empty-state.vue";
import ReportBySDG from "./sdg-impact-by-sdg.vue";
import ChartsWidget from "./charts-widget.vue";
import ChartsWrapper from "../../components/common/charts-wrapper/charts-wrapper.vue";
import ReportByCompany from "./sdg-impact-by-company.vue";
import ViTabs from "@/components/elements/vi-tabs/vi-tabs.vue";
import ViSelect from "@/components/elements/vi-select/vi-select.vue";

import { useCompanyList } from "./../../composables/useCompanyList";


export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  setup(__props) {

const {
  lists,
  selectedList,
  gotoSelectedList,
  gotoListCreationPage,
  emptyOrNoList,
} = useCompanyList();

const tabs = ref([
  {
    id: "by-company",
    label: "Impact by Company",
    component: ReportByCompany,
  },
  {
    id: "by-sdg",
    label: "Impact by SDG",
    component: ReportBySDG,
  },
]);

const selectedTab = ref(tabs.value[0].id);
const handleTabChange = (tabName: string) => {
  selectedTab.value = tabName;
};
const onListSelect = (listUid: string) => {
  selectedList.value = listUid;
};

return (_ctx: any,_cache: any) => {
  const _component_PxButton = _resolveComponent("PxButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("header", null, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", null, _toDisplayString(_ctx.$t(`chartsDashboard.select[0]`)), 1),
        _createVNode(ViSelect, {
          "option-key-key": "uid",
          "option-value-key": "uid",
          "option-label-key": "title",
          options: _unref(lists),
          "selected-option": _unref(selectedList),
          onChange: onListSelect
        }, null, 8, ["options", "selected-option"])
      ]),
      _createVNode(_component_PxButton, {
        disabled: _unref(emptyOrNoList),
        size: "medium",
        icon: "download"
      }, {
        default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
          _createTextVNode(" Download Full Report ", -1)
        ]))]),
        _: 1
      }, 8, ["disabled"])
    ]),
    _createVNode(ChartsWrapper, null, {
      default: _withCtx(() => [
        (_unref(emptyOrNoList))
          ? (_openBlock(), _createBlock(EmptyState, {
              key: 0,
              type: _unref(lists).length <= 0 ? `lists` : `companies`,
              "on-open-list": _unref(gotoSelectedList),
              "on-create-list": _unref(gotoListCreationPage)
            }, null, 8, ["type", "on-open-list", "on-create-list"]))
          : (_openBlock(), _createBlock(ChartsWidget, { key: 1 }, {
              default: _withCtx(() => [
                _createVNode(ViTabs, {
                  tabs: tabs.value,
                  "selected-tab": selectedTab.value,
                  onChange: handleTabChange
                }, null, 8, ["tabs", "selected-tab"])
              ]),
              _: 1
            }))
      ]),
      _: 1
    })
  ]))
}
}

})